<template>
  <!-- 供电统计面板 -->
  <div>
    <div class="fr ov pane-overall pl-20" style="height: 135px; width: 100%">
      <div id="chartDiv" ref="chartDiv" style="width: 131px; height: 135px;" />
      <div class="fc" style="width: 120px; height: 135px;">
        <div class="fc jc ac pane-data-block">
          <div class="pane-data-label">{{ itUsage ? itUsage.name : '' }}</div>
          <div class="pane-data-value" :style="{ color: colors[0] }">{{ itUsage ? itUsage.value : '' }}</div>
        </div>
        <div class="fc jc ac pane-data-block">
          <div class="pane-data-label">{{ powerDevUsage ? powerDevUsage.name : '' }}</div>
          <div class="pane-data-value" :style="{ color: colors[2] }">{{ powerDevUsage ? powerDevUsage.value : '' }}</div>
        </div>
      </div>
      <div class="fc" style="width: 120px; height: 135px;">
        <div class="fc jc ac pane-data-block">
          <div class="pane-data-label">{{ acUsage ? acUsage.name : '' }}</div>
          <div class="pane-data-value" :style="{ color: colors[1] }">{{ acUsage ? acUsage.value : '' }}</div>
        </div>
        <div class="fc jc ac pane-data-block">
          <div class="pane-data-label">{{ assistDevUsage ? assistDevUsage.name : '' }}</div>
          <div class="pane-data-value" :style="{ color: colors[3] }">{{ assistDevUsage ? assistDevUsage.value : '' }}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: 'pane-energy-usage',
  components: {},
  props: {
    chartData: {
      type: Array,
      required: true,
    },
  },
  watch: {
    chartData: {
      deep: true,
      handler () {
        this.update()
      }
    }
  },
  data() {
    return {
      itUsage: { name:'', value: '' },
      acUsage: { name:'', value: '' },
      powerDevUsage: { name:'', value: '' },
      assistDevUsage: { name:'', value: '' },

      chart: null,
      colors: [ '#FFC400', '#8AFCED', '#5A79FF', '#F67B7B' ], // 颜色列表
    }
  },
  mounted () {
    const chart = echarts.init(this.$refs.chartDiv)
    window.addEventListener('resize', () => {
      setTimeout(() => {chart.resize()}, 10)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', () => chart.resize())
      chart.dispose()
    })
    this.chart = chart

    this.$nextTick(function () {
      this.update()
    })
  },
  methods: {
    update () {
      if (!this.chartData) return
      this.itUsage = this.chartData[0]
      this.acUsage = this.chartData[1]
      this.powerDevUsage = this.chartData[2]
      this.assistDevUsage = this.chartData[3]

      const option = {
        color: this.colors,
        legend: {
          show: false,
        },
        tooltip: {
          show: false,
        },

        series: [
          {
            type: 'pie',
            radius: ['50%', '80%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: this.chartData
          }
        ]
      }
      this.chart.setOption(option)
    },
  }
}
</script>

<style lang="css" scoped>

.pane-overall {
  width: 100%;
  background: rgba(0, 145, 133, 0.12);
}

.pane-data-block {
  width: 120px;
  height: 48%;
  background: rgba(0,0,0,0);
}

.pane-data-value {
  line-height: 26px;
  font-size: 26px;
  font-family: Consolas, serif;
  color: #35FFF6;
  text-align: center;
  vertical-align: center;
  font-family: aldrich, serif;
  padding-top: 5px;
}

.pane-data-label {
  line-height: 16px;
  font-size: 12px;
  color: #FFF;
}

</style>
